<nz-form-item class="input-field title-14">
	<nz-form-control [formGroup]="form">
		<div>
			<span class="color-grey">{{label}} :</span>
		</div>
		<nz-select *ngIf="!IsArrayObject" [nzPlaceHolder]="placeholder" nzShowSearch nzAllowClear (ngModelChange)="handleOnModelChange($event)" (nzOnSearch)="handleOnSearch($event)" [nzServerSearch]="serverSearch" [formControlName]="formName" class="full-width" nzSize="medium">
			<nz-option *ngFor="let option of selectionArray" [nzLabel]="option" [nzValue]="option"></nz-option>
		</nz-select>
		<nz-select *ngIf="IsArrayObject" [nzPlaceHolder]="placeholder" nzShowSearch nzAllowClear (ngModelChange)="handleOnModelChange($event)" (nzOnSearch)="handleOnSearch($event)" [nzServerSearch]="serverSearch" [formControlName]="formName" class="full-width" nzSize="medium">
			<nz-option *ngFor="let option of selectionArray" [nzLabel]="option.label" [nzValue]="option.value">
			</nz-option>
		</nz-select>

		<app-validation-errors
			*ngIf="showValidationError && (this.form?.controls[this.formName].touched || this.form?.controls[this.formName].dirty)"
			[errors]="this.form?.get(this.formName).errors" label="{{this.formName}}">
		</app-validation-errors>
	</nz-form-control>
</nz-form-item>
